import { graphql } from '~/lib/graphql'

export const MemberDiscountCoupons = graphql(`
  fragment MemberDiscountCoupons on ReserveInfoMember {
    discountCoupons {
      code
      name
      discountAmount
      minimumReservationAmount
      viewerAcquired
      reservablePeriod {
        from
        to
      }
      visitablePeriod {
        from
        to
      }
      usableMemberCount
    }
  }
`)
